/* Ripped Lab — TDEE & macros engine.
   Υλοποιεί επακριβώς το Reference Manual (§1-7, §12.3): Mifflin-St Jeor,
   NEAT multiplier (εργασία μόνο), Steps kcal, Exercise kcal με density,
   στόχους ανά ημέρα προπόνησης/ρεπό, macros με 40% trigger λιπαρών.
   Όλα υπολογίζονται client-side — τίποτα δεν αποθηκεύεται ή αποστέλλεται. */
(function () {
  var root = document.querySelector('[data-calculator]');

  var NEAT = { sedentary: 1.15, light: 1.20, moderate: 1.25, manual: 1.35 };
  var EXERCISE_KCAL_H = { strength: 250, mixed: 350, hiit: 450, cardio: 400 };
  var DENSITY = { powerlifting: 0.75, standard: 1.0, pump: 1.25, circuit: 1.5 };
  var GOALS = {
    cut:     { protein: 2.4, workout: -300, rest: -300 },
    maint:   { protein: 2.2, workout: 0,    rest: 0 },
    recomp:  { protein: 2.2, workout: 100,  rest: 0 },
    bulk:    { protein: 2.2, workout: 300,  rest: 150 }
  };

  /* §7.2 — 40% trigger, εφαρμόζεται ξεχωριστά ανά ημέρα */
  function fatsForDay(targetKcal, weight) {
    var fats = weight * 1.0;                       // default 1.0 g/kg
    if ((fats * 9) / targetKcal > 0.40) {
      fats = (targetKcal * 0.40) / 9;
      if (fats / weight < 0.8) fats = weight * 0.8; // floor 0.8 g/kg
    }
    return Math.round(fats);
  }

  /* Αριθμητική συμβατή με το Reference Manual §14:
     ενδιάμεσα στρογγυλοποιούνται (NEAT & Exercise σε 0.1 kcal, Steps σε 1 kcal)
     πριν την άθροιση των TDEE. */
  var r1 = function (x) { return Math.round(x * 10) / 10; };

  function compute(input) {
    var bmr = 10 * input.weight + 6.25 * input.height - 5 * input.age + (input.sex === 'm' ? 5 : -161);
    var neatBase = r1(bmr * NEAT[input.work]);
    var stepsKcal = Math.round(input.steps * 0.04 * (input.weight / 70));

    var exercisePerDay = 0;
    input.trainings.forEach(function (t) {
      exercisePerDay += (EXERCISE_KCAL_H[t.type] * (t.minutes / 60) * DENSITY[t.density] * t.perWeek) / 7;
    });
    exercisePerDay = r1(exercisePerDay);

    var tdeeRest = neatBase + stepsKcal;
    var tdeeWorkout = neatBase + stepsKcal + exercisePerDay;
    var g = GOALS[input.goal];
    var targetRest = Math.round(tdeeRest + g.rest);
    var targetWorkout = Math.round(tdeeWorkout + g.workout);

    var protein = Math.round(input.weight * g.protein);
    var fatsRest = fatsForDay(targetRest, input.weight);
    var fatsWorkout = fatsForDay(targetWorkout, input.weight);
    var carbsRest = Math.round((targetRest - protein * 4 - fatsRest * 9) / 4);
    var carbsWorkout = Math.round((targetWorkout - protein * 4 - fatsWorkout * 9) / 4);

    return {
      bmr: Math.round(bmr), neatBase: Math.round(neatBase),
      stepsKcal: Math.round(stepsKcal), exercisePerDay: Math.round(exercisePerDay),
      tdeeRest: Math.round(tdeeRest), tdeeWorkout: Math.round(tdeeWorkout),
      targetRest: targetRest, targetWorkout: targetWorkout,
      protein: protein, fatsRest: fatsRest, fatsWorkout: fatsWorkout,
      carbsRest: Math.max(0, carbsRest), carbsWorkout: Math.max(0, carbsWorkout),
      waterMin: Math.round(input.weight * 30), waterMax: Math.round(input.weight * 35)
    };
  }

  /* expose για tests & για τη σελίδα «Φτιάξε το πλάνο σου» (που φορτώνει μόνο τη μηχανή) */
  var SS_CALC = 'rl-calc-input';
  window.RLCalc = { compute: compute, storageKey: SS_CALC };
  if (!root) return;

  /* ---------- UI wiring ---------- */
  var state = { sex: 'm', goal: 'maint' };
  var fmt = function (n) { return n.toLocaleString('el-GR'); };

  /* hint popovers */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.hint');
    if (!btn) return;
    var pop = btn.closest('.field').querySelector('.hint-pop');
    var open = pop.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* goal descriptions */
  var GOAL_DESC = {
    cut: 'Θες να δεις τη ζυγαριά να κατεβαίνει. Ελεγχόμενο έλλειμμα −300 kcal και αυξημένη πρωτεΐνη, ώστε να φεύγει λίπος — όχι μυς.',
    maint: 'Είσαι ικανοποιημένος με το βάρος σου και θες να τρέφεσαι σωστά για ενέργεια, απόδοση και υγεία.',
    recomp: 'Θες πιο «σφιχτό», πιο γραμμωμένο σώμα χωρίς μεγάλη αλλαγή στη ζυγαριά: χτίζεις μυ και χάνεις λίπος ταυτόχρονα. Ιδανικό αν ξεκινάς τώρα βάρη ή επιστρέφεις από διάλειμμα.',
    bulk: 'Θες να μεγαλώσεις — περισσότερος μυς, περισσότερη δύναμη. Ελεγχόμενο πλεόνασμα (+300 kcal τις μέρες προπόνησης) για μάζα με το ελάχιστο δυνατό λίπος.'
  };

  root.querySelectorAll('[data-sex]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-sex]').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on'); state.sex = b.dataset.sex;
    });
  });
  root.querySelectorAll('[data-goal]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-goal]').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on'); state.goal = b.dataset.goal;
      var d = document.getElementById('goal-desc');
      if (d) d.textContent = GOAL_DESC[state.goal];
    });
  });

  /* δεύτερο μπλοκ προπόνησης on demand (§5.4) — προστίθεται και αφαιρείται */
  var addBtn = document.getElementById('add-training');
  var removeBtn = document.getElementById('remove-training');
  var block2 = document.getElementById('training-2');
  if (addBtn && block2) {
    var addWrap = addBtn.parentNode;
    addBtn.addEventListener('click', function () {
      block2.hidden = false;
      addWrap.hidden = true;
      block2.querySelector('.t-freq').focus();
    });
  }
  if (removeBtn && block2 && addBtn) {
    removeBtn.addEventListener('click', function () {
      block2.hidden = true;
      addBtn.parentNode.hidden = false;
      /* μηδενισμός ώστε να μη μετράει πια στο readTrainings, + ζωντανός επανυπολογισμός */
      var freq = block2.querySelector('.t-freq');
      freq.value = 0;
      block2.querySelector('.t-min').value = 30;
      freq.dispatchEvent(new Event('input', { bubbles: true }));
      addBtn.focus();
    });
  }

  /* density εμφανίζεται μόνο για στυλ με νόημα (δύναμη/mixed) */
  root.querySelectorAll('[data-training]').forEach(function (block) {
    var typeSel = block.querySelector('.t-type');
    var densWrap = block.querySelector('.t-density-wrap');
    typeSel.addEventListener('change', function () {
      var show = typeSel.value === 'strength' || typeSel.value === 'mixed';
      densWrap.hidden = !show;
      if (!show) block.querySelector('.t-density').value = 'standard';
    });
  });

  function readTrainings() {
    var list = [];
    root.querySelectorAll('[data-training]').forEach(function (block) {
      if (block.hidden) return;
      var perWeek = +block.querySelector('.t-freq').value;
      var minutes = +block.querySelector('.t-min').value;
      if (!perWeek || !minutes) return;
      minutes = Math.min(120, Math.max(30, minutes)); // §5.5 floor/ceiling
      list.push({
        type: block.querySelector('.t-type').value,
        perWeek: perWeek, minutes: minutes,
        density: block.querySelector('.t-density').value
      });
    });
    return list;
  }

  function renderResult(r) {
    var set = function (id, val) { document.getElementById(id).textContent = val; };
    set('r-bmr', fmt(r.bmr)); set('r-neat', fmt(r.neatBase));
    set('r-steps', fmt(r.stepsKcal)); set('r-ex', fmt(r.exercisePerDay));
    set('r-tdee-rest', fmt(r.tdeeRest)); set('r-tdee-w', fmt(r.tdeeWorkout));
    set('r-t-rest', fmt(r.targetRest)); set('r-t-w', fmt(r.targetWorkout));
    set('r-p-rest', r.protein + ' g'); set('r-p-w', r.protein + ' g');
    set('r-f-rest', r.fatsRest + ' g'); set('r-f-w', r.fatsWorkout + ' g');
    set('r-c-rest', r.carbsRest + ' g'); set('r-c-w', r.carbsWorkout + ' g');
    set('r-water', fmt(r.waterMin) + '–' + fmt(r.waterMax) + ' ml');
    var card = document.getElementById('result-card');
    card.hidden = false;
    document.getElementById('result-empty').hidden = true;
    /* ζωντανή σύνοψη στόχων δίπλα στο κουμπί — ορατή και στο τέλος της φόρμας */
    var lt = document.getElementById('live-targets');
    if (lt) {
      lt.hidden = false;
      lt.textContent = 'Στόχοι: ' + fmt(r.targetRest) + ' kcal ρεπό · ' + fmt(r.targetWorkout) + ' kcal προπόνησης';
    }
    /* μικρό flash στις τιμές ώστε να φαίνεται η ζωντανή αλλαγή */
    card.classList.remove('tick');
    void card.offsetWidth;
    card.classList.add('tick');
  }

  function runCompute(interactive) {
    var workSel = document.getElementById('f-work');
    if (!workSel.value) {
      if (interactive) { workSel.reportValidity(); workSel.focus(); }
      return false;
    }
    var input = {
      sex: state.sex, goal: state.goal,
      age: +document.getElementById('f-age').value || 30,
      height: +document.getElementById('f-h').value || 175,
      weight: +document.getElementById('f-w').value || 75,
      work: workSel.value,
      steps: +document.getElementById('f-steps').value || 0,
      trainings: readTrainings()
    };
    var r = compute(input);
    /* διαθέσιμο στη σελίδα «Φτιάξε το πλάνο σου»: sessionStorage της συσκευής, σβήνει με το tab — τίποτα σε server */
    window.RLCalc.last = r;
    window.RLCalc.lastInput = input;
    try { sessionStorage.setItem(SS_CALC, JSON.stringify(input)); } catch (x) {}
    document.dispatchEvent(new CustomEvent('rlcalc:done'));
    renderResult(r);
    root.querySelectorAll('[data-plan-cta]').forEach(function (p) { p.hidden = false; });
    return true;
  }

  /* Ζωντανή ενημέρωση: κάθε αλλαγή σε πεδίο/επιλογή επανυπολογίζει το προφίλ
     (χωρίς validation popups — αυτά μόνο στο ρητό πάτημα του κουμπιού) */
  var liveTimer;
  function live() {
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () { runCompute(false); }, 150);
  }
  root.addEventListener('input', live);
  root.addEventListener('change', live);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sex],[data-goal]')) live();
  });

  /* Επιστροφή από το Βήμα 2 («Άλλαξε τα νούμερά σου»): ξαναγέμισε τη φόρμα από τη συσκευή */
  try {
    var saved = JSON.parse(sessionStorage.getItem(SS_CALC) || 'null');
    if (saved && saved.work) {
      var setV = function (id, v) { var el = document.getElementById(id); if (el && v != null) el.value = v; };
      root.querySelectorAll('[data-sex]').forEach(function (b) { b.classList.toggle('on', b.dataset.sex === saved.sex); }); state.sex = saved.sex;
      root.querySelectorAll('[data-goal]').forEach(function (b) { b.classList.toggle('on', b.dataset.goal === saved.goal); }); state.goal = saved.goal;
      var gd = document.getElementById('goal-desc'); if (gd) gd.textContent = GOAL_DESC[state.goal];
      setV('f-age', saved.age); setV('f-h', saved.height); setV('f-w', saved.weight); setV('f-steps', saved.steps); setV('f-work', saved.work);
      var t1 = saved.trainings[0], b1 = document.getElementById('training-1');
      if (t1 && b1) { b1.querySelector('.t-type').value = t1.type; b1.querySelector('.t-density').value = t1.density; b1.querySelector('.t-freq').value = t1.perWeek; b1.querySelector('.t-min').value = t1.minutes; b1.querySelector('.t-density-wrap').hidden = !(t1.type === 'strength' || t1.type === 'mixed'); }
      var t2 = saved.trainings[1], b2 = document.getElementById('training-2');
      if (t2 && b2) { b2.hidden = false; if (addBtn) addBtn.parentNode.hidden = true; b2.querySelector('.t-type').value = t2.type; b2.querySelector('.t-density').value = t2.density; b2.querySelector('.t-freq').value = t2.perWeek; b2.querySelector('.t-min').value = t2.minutes; }
      runCompute(false);
    }
  } catch (x) {}
})();
